import { AiChat } from '@/assets/icons'
import { Button } from '@/components/button/Button'
import { useStartTimelineAssetChat } from '../hooks/useStartTimelineAssetChat'

interface TimelineAssetChatButtonProps {
  assetId: string
  matterId: string
}

/**
 * Starts a new assistant chat grounded in the matter's living Timeline.
 */
export default function TimelineAssetChatButton(props: TimelineAssetChatButtonProps) {
  const { assetId, matterId } = props
  const { isLoading, startChat } = useStartTimelineAssetChat({ assetId, matterId })

  return (
    <Button
      onClick={() => startChat()}
      disabled={isLoading}
      loading={isLoading}
      variant="outlined"
      color="primary"
      size="sm"
      leadingIcon={<AiChat />}
      aria-label="Chat with the Timeline"
    >
      Ask Assistant
    </Button>
  )
}
